// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 2.5rem;
  padding: 2.5rem;
  max-width: 1200px;
  margin: 0 auto;
}

.system-card {
  height: 370px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
  padding: 2rem;
  text-decoration: none;
  color: white;
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  overflow: hidden;
  z-index: 1;
  background-size: cover;
  background-position: center;
}

.system-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(50, 50, 50, 0.75);
  z-index: -1;
  transition: opacity 0.4s ease;
}

.system-card:hover {
  transform: scale(1.05);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
}

.system-card:hover::before {
  opacity: 0.85;
}

.system-icon {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.system-card:hover .system-icon {
  transform: scale(1.15);
}

.system-title {
  margin: 0 0 1.25rem 0;
  font-size: 2rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.system-description {
  margin: 0;
  font-size: 1.2rem;
  opacity: 0.95;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  max-width: 90%;
}

@media (max-width: 768px) {
  .system-grid {
    grid-template-columns: 1fr;
    padding: 1.5rem;
    gap: 2rem;
  }
  
  .system-card {
    height: 300px;
  }
  
  .system-title {
    font-size: 1.8rem;
  }
  
  .system-description {
    font-size: 1.1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SystemGrid.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".system-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  gap: 2.5rem;\n  padding: 2.5rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.system-card {\n  height: 370px;\n  border-radius: 12px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);\n  padding: 2rem;\n  text-decoration: none;\n  color: white;\n  transition: all 0.4s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  background-size: cover;\n  background-position: center;\n}\n\n.system-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(50, 50, 50, 0.75);\n  z-index: -1;\n  transition: opacity 0.4s ease;\n}\n\n.system-card:hover {\n  transform: scale(1.05);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);\n}\n\n.system-card:hover::before {\n  opacity: 0.85;\n}\n\n.system-icon {\n  font-size: 3.5rem;\n  margin-bottom: 1.5rem;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  transition: transform 0.3s ease;\n}\n\n.system-card:hover .system-icon {\n  transform: scale(1.15);\n}\n\n.system-title {\n  margin: 0 0 1.25rem 0;\n  font-size: 2rem;\n  font-weight: 700;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.system-description {\n  margin: 0;\n  font-size: 1.2rem;\n  opacity: 0.95;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n  max-width: 90%;\n}\n\n@media (max-width: 768px) {\n  .system-grid {\n    grid-template-columns: 1fr;\n    padding: 1.5rem;\n    gap: 2rem;\n  }\n  \n  .system-card {\n    height: 300px;\n  }\n  \n  .system-title {\n    font-size: 1.8rem;\n  }\n  \n  .system-description {\n    font-size: 1.1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
